const EyeSvg = ({ size = 8 }) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={`-m-[3px] size-${size}`}
  >
    <path
      d="M1.35684 8.71493C1.31078 8.57676 1.31074 8.42716 1.35671 8.28895C2.28229 5.50648 4.907 3.5 8.00035 3.5C11.0923 3.5 13.716 5.50462 14.6427 8.28507C14.6887 8.42325 14.6888 8.57285 14.6428 8.71105C13.7172 11.4935 11.0925 13.5 7.99918 13.5C4.90727 13.5 2.28356 11.4954 1.35684 8.71493Z"
      stroke="#1054B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99981 8.5C9.99981 9.60457 9.10437 10.5 7.9998 10.5C6.89524 10.5 5.9998 9.60457 5.9998 8.5C5.9998 7.39543 6.89524 6.5 7.9998 6.5C9.10437 6.5 9.99981 7.39543 9.99981 8.5Z"
      stroke="#1054B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeSvg;
